import { CircularProgress, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { useAsyncAction } from 'app/services';
import { groupItemsSelector } from 'app/selectors/transport';
import { transportGroupLoad } from 'app/store/transport';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
const TransportMenu = ({ open, onClose, onChange, anchorEl }) => {
    const groupItems = useSelector(groupItemsSelector);
    const { asyncAction: fetchData, isLoading: isFetchLoading } = useAsyncAction(transportGroupLoad);
    const sortItems = useMemo(() => {
        const compareFn = (a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
        return [...groupItems].sort(compareFn);
    }, [groupItems]);
    useEffect(() => {
        if (open) {
            fetchData();
        }
    }, [open]);
    return (React.createElement(Menu, { open: open, onClose: onClose, anchorEl: anchorEl, PaperProps: {
            sx: (theme) => ({
                width: '200px',
                height: '200px',
                overflow: 'auto',
                marginTop: theme.spacing(1.5),
                '&:before': {
                    right: '10px',
                },
            }),
        }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        } },
        isFetchLoading && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                width: '100%',
                height: '155px',
            } },
            React.createElement(CircularProgress, { size: 20 }))),
        !isFetchLoading && !groupItems.length && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                marginTop: '35px',
                width: '100%',
                height: '100%',
                padding: '5px',
            } },
            React.createElement(Typography, { align: 'center', variant: 'body1', component: 'div' }, "\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u043A\u0430 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435\u0442"),
            React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'div' }, "\u0412 \u044D\u0442\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u0433\u0440\u0443\u043F\u043F\u044B \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432"))),
        !isFetchLoading &&
            sortItems.map((value, key) => (React.createElement(MenuItem, { key: key, disableRipple: true, onClick: () => onChange(value.id) }, value.name)))));
};
export default TransportMenu;
